export default "__VITE_ASSET__DmDidyfI__"